import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { BrowserRouter } from 'react-router-dom';
import './styles.css';

import { HelmetProvider } from 'react-helmet-async';

// Bootstrap the React application into the #root element.
// We use a check to determine if we should hydrate (for react-snap pre-rendered HTML)
// or render from scratch (for local development).

const rootElement = document.getElementById('root');
const app = (
  <HelmetProvider>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}